import { render, staticRenderFns } from "./ArtPage1.vue?vue&type=template&id=5d222a30&scoped=true"
import script from "./ArtPage1.vue?vue&type=script&lang=js"
export * from "./ArtPage1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d222a30",
  null
  
)

export default component.exports